<span nzGutter="8" nz-tooltip [nzTooltipTitle]="text" [nzTooltipVisible]="!!text">
  <i
    [ngStyle]="{ 'font-size': iconSize }"
    class="warning-icon"
    nz-icon
    nzType="warning"
    nzTheme="twotone"
    nzTwotoneColor="#F55D2D"
  ></i>
</span>
